import { injectable, postConstruct } from 'inversify'
import { IUser, User } from '@/model/user'
import { Auth0UserProfile } from 'auth0-js';
import { MetaService, MetaServiceImpl } from '@/service/MetaService';

export interface UserService extends MetaService<IUser> {
  getMe (): Promise<IUser|null>
  getUserByToken (token: string): Promise<IUser|null>
}

@injectable()
export class UserServiceImpl extends MetaServiceImpl<IUser> implements UserService {
  @postConstruct()
  public initialize () {
    this.serviceName = 'users'
  }
  
  public getMe(): Promise<IUser | null> {
    return new Promise<IUser|null>((resolve, reject) => {
      this.getApiService().getSingle<IUser>(`${ this.serviceName }/me/`).then((user: IUser | null) => {
        if(user) {
          return resolve(user)
        } else {
          return resolve(null)
        }
      }).catch((err) => {
        console.log('Me: Error getting user: %j', err)
        return resolve(null)
      })
    })
  }

  public getUserByToken (token: string): Promise<IUser|null> {
    return new Promise<IUser|null>((resolve, reject) => {
      this.webAuthContainer.webAuth.client.userInfo(token, function(err, userProfile: Auth0UserProfile) {
        if(err) {
          console.log('Error getting auth0 user: %j', err)
          return resolve(null)
        }
        let user = new User();
        user.email = userProfile.email ? userProfile.email : null
        user.name = userProfile.name
        user.firstName = userProfile.given_name ? userProfile.given_name : null
        return resolve(user)
      });
    })
  }
}
